import { eventsApi } from "@/api";
import { callYaMetrika } from "./call-ya-metrika";

export const emitViewPhotoLimitEvent = () => {
    const event = 'view_photo_limit'
    callYaMetrika(event)
    eventsApi.logUserEventWithoutResponse(event)
};
